var
	CURRENCIES = {
		'EUR': '€'
	}
;


export function price(amount, type, currency) {
	const result = [];

	if (type === 'FREE') {

		// Free
		result.push('Zu verschenken');

	} else {

		// Price and currency
		if (amount) {
			result.push(amount);
			result.push(CURRENCIES[currency]);
		}

		// VB
		if (type === 'PLEASE_CONTACT') {
			result.push('VB');
		}

	}

	return result.join(' ');
}
